import {AfterViewInit, Component, ElementRef, Input} from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ui-card',
    templateUrl: './ui-card.component.html'
})
export class UICardComponent implements AfterViewInit {

    constructor(
        private host: ElementRef<HTMLElement>
    ) {
    }

    private _mode: 'default' | 'critical' | 'success' | 'primary' | 'warning' = 'default';

    @Input() set mode(value: typeof this._mode) {
        this._mode = value;
        this.updateBackgroundMode();
    };

    get backgroundColor() {
        return `≈bg-${this._mode === 'default' ? 'surface' : `${this._mode}-actions`}-default`;
    }

    ngAfterViewInit() {
        const backgroundClass = this.backgroundColor;
        const originalClassList = Array.from(this.host.nativeElement.classList);
        const mandatoryClasses = [backgroundClass, '≈rounded', 'md:≈rounded-md', 'lg:≈rounded-lg', '≈shadow-sm', 'sm:≈shadow', 'md:≈shadow-md'];

        // this.host.nativeElement.classList.remove(...originalClassList);
        this.host.nativeElement.classList.add(...mandatoryClasses);
    }

    updateBackgroundMode() {
        const backgroundsToRemove = Array.from(this.host.nativeElement.classList)
            .filter(c => /^≈bg-/gmi.test(c));
        const backgroundClass = this.backgroundColor;
        this.host.nativeElement.classList.remove(...backgroundsToRemove);
        this.host.nativeElement.classList.add(backgroundClass);
    }
}
